module.exports = __webpack_public_path__ + "img/logo-pertamina-retail.214033cb.png";